// ABOUTME: Loads the selected plant's schedule for the current local day.
// ABOUTME: Calculates query boundaries using timezone metadata from UPM.
import {roundTo15MinIntervalStart} from '@hconnect/common/utils'
import moment from 'moment-timezone'

import {useUrlParam} from '../../../routing'
import {useSettingsQuery} from '../../providers/ApiInterface'
import {useSettingsPlant} from '../useSettingsPlant'

export const useScheduleQuery = (isDisabled = false) => {
  const plantCode = useUrlParam('plantCode')
  const plant = useSettingsPlant()

  // TODO: should be resolved by HCP-60882
  // this logic is for currently to match default time range in planner
  const startOfToday = moment.utc().tz(plant.timezone).startOf('day')
  const start = roundTo15MinIntervalStart(moment.utc().tz(plant.timezone))
  const end = startOfToday.clone().add(8, 'days')

  return useSettingsQuery(
    'schedule',
    [{plantCode, start: start.toISOString(), end: end.toISOString()}],
    {
      enabled: !isDisabled
    }
  )
}
